import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="narrow-list"
// タスクが無いリストをナロー状態（縮小表示）にするコントローラー
// ナロー状態の初期設定はサーバーサイドで行い、ここではナロー解除のみ行う
export default class extends Controller {
  static values = {
    listId: String,
    progressId: String,
    projectId: String,
    assigneeId: String
  }

  connect() {
    this.setupDragListeners()
  }

  disconnect() {
    this.removeDragListeners()
  }

  // ネイティブドラッグイベントのセットアップ（SortableJSもHTML5 Drag APIを使用）
  setupDragListeners() {
    this.boundDragEnter = this.handleDragEnter.bind(this)
    this.boundDragOver = this.handleDragOver.bind(this)
    this.boundDragLeave = this.handleDragLeave.bind(this)
    this.boundDrop = this.handleDrop.bind(this)

    this.element.addEventListener('dragenter', this.boundDragEnter)
    this.element.addEventListener('dragover', this.boundDragOver)
    this.element.addEventListener('dragleave', this.boundDragLeave)
    this.element.addEventListener('drop', this.boundDrop)

    // ドラッグ終了をドキュメント全体で検知
    this.boundDragEnd = this.handleDragEnd.bind(this)
    document.addEventListener('dragend', this.boundDragEnd)
  }

  removeDragListeners() {
    this.element.removeEventListener('dragenter', this.boundDragEnter)
    this.element.removeEventListener('dragover', this.boundDragOver)
    this.element.removeEventListener('dragleave', this.boundDragLeave)
    this.element.removeEventListener('drop', this.boundDrop)
    document.removeEventListener('dragend', this.boundDragEnd)
  }

  // ドラッグがリストに入った時
  handleDragEnter(event) {
    if (!this.isNarrow()) return

    // ナロー状態を解除して通常表示にする
    this.element.classList.add('drag-over')
  }

  // ドラッグオーバー中（dragenterの後も継続的に発火）
  handleDragOver(event) {
    // ドロップを許可するために必要
    if (this.element.classList.contains('drag-over')) {
      event.preventDefault()
    }
  }

  // ドラッグがリストから出た時
  handleDragLeave(event) {
    // 子要素への移動は無視
    if (this.element.contains(event.relatedTarget)) return

    this.element.classList.remove('drag-over')
  }

  // ドロップされた時
  handleDrop(event) {
    this.element.classList.remove('drag-over')
    // ドロップ後はタスクがあるのでナロー解除を維持
    this.expand()
  }

  // ドラッグ終了時（ドキュメント全体で検知）
  handleDragEnd(event) {
    this.element.classList.remove('drag-over')
  }

  // "+"ボタンをクリックしてタスク追加フォームを開く時
  expandForNewTask(event) {
    if (this.isNarrow()) {
      this.expand()
    }
  }

  // ナロー状態かどうか
  isNarrow() {
    return this.element.classList.contains('narrow')
  }

  // 展開する
  expand() {
    this.element.classList.remove('narrow')
  }
}
